import { parsippanyConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function ParsippanyPage() {
  return <CityPageTemplate config={parsippanyConfig} />;
}